export const MOODS = [
  { id: "furious", label: "Furious", color: "#FF3B30", bg: "rgba(255, 59, 48, 0.15)", icon: "Flame" },
  { id: "anxious", label: "Anxious", color: "#FF9500", bg: "rgba(255, 149, 0, 0.15)", icon: "Zap" },
  { id: "exhausted", label: "Exhausted", color: "#8E8E93", bg: "rgba(142, 142, 147, 0.15)", icon: "BatteryLow" },
  { id: "heartbroken", label: "Heartbroken", color: "#AF52DE", bg: "rgba(175, 82, 222, 0.15)", icon: "HeartOff" },
  { id: "overwhelmed", label: "Overwhelmed", color: "#5856D6", bg: "rgba(88, 86, 214, 0.15)", icon: "CloudRain" },
  { id: "relieved", label: "Relieved", color: "#34C759", bg: "rgba(52, 199, 89, 0.15)", icon: "Wind" },
];

export const CATEGORIES = ["Work", "Relationships", "Family", "Life", "Money", "Health", "Random"];

export const REACTIONS = [
  { id: "feel_you", label: "I feel you", emoji: "🤝" },
  { id: "same", label: "Same", emoji: "🔥" },
  { id: "hug", label: "Hug", emoji: "🫂" },
  { id: "stay_strong", label: "Stay strong", emoji: "🛡️" },
  { id: "screw_that", label: "F*** that", emoji: "⚡" },
];

export function moodById(id) {
  return MOODS.find((m) => m.id === id) || MOODS[0];
}

export function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString();
}
